var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0L0 2L4.5 5V10L7.5 12V5L12 2V0L0 0Z","fill":"currentColor"}));
}

Filter.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Filter;

Filter.default = Filter;
